import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c0f6f14e&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/mychefkoo/Documents/cloud-dom/cloud-web/erp-flexible-web21/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c0f6f14e')) {
      api.createRecord('c0f6f14e', component.options)
    } else {
      api.reload('c0f6f14e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=c0f6f14e&", function () {
      api.rerender('c0f6f14e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/emailTemplate/index.vue"
export default component.exports